const mapCurrencyFromApi = (apiCurrency: ApiCurrency): Currency => apiCurrency;

export default mapCurrencyFromApi;
